module.exports = __webpack_public_path__ + "static/media/ico-tracing.06553268.svg";